<template>
    <li
    v-if="project.length != 0"
    class="project-box">
        <div class="title">
            <h1>专题</h1>
            <el-link
            type="primary"
            :underline="false"
            :href="'/Index/wjs_search_res.html?kw=' + $route.query.name + '&cgy=zt'"
            target="_blank">
            更多></el-link>
        </div>

        <div class="con project">
            <a
            v-for="(i, index) of project.slice(0, 8)"
            :key="index"
            :href="i.body"
            target="_blank">
                <div class="zt-con">
                    <div class="zt-banner">
                        <img v-if="i.image" :src="'' + i.image">
                        <div v-else class="zt-banner-default">
                            <img :src="defaultImageSrc">
                            <span class="default-title">{{i.title}}</span>
                        </div>
                    </div>
                    <p>{{i.title}}</p>
                </div>
            </a>
        </div>
    </li>
</template>

<script>
export default {
    name: 'project',
    data() {
        return {
            project: [],
            defaultImageSrc: '/Public/home/images/wjs_bg.jpg'
        }
    },
    mounted() {
        axios.get('/Index/topic_json?p=1&title=' + this.$route.query.name)
        .then((res) => {
            if(res.data.list.length != 0) {
                res.data.list.forEach(item => {
                    if(item.cname != '下属子网' && item.cname != '微专题' && item.cname != '报告类'){
                        this.project.push(item)
                    }
                })
            }
        })
    }
}
</script>

<style scoped>
.zt-banner-default {
    position: relative;
    overflow: hidden;
}
.zt-banner-default img {
    width: 100%;
    /* height: 160px; */
    transition: all .3s ease;
}
.default-title {
    position: absolute;
    width: 80%;
    top: 23%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 19px;
    text-shadow: 2px 2px 4px #000000;
}
.project {
    display: flex;
    flex-wrap: wrap;
}
.project a {
    flex: 0 0 25%;
    margin-bottom: 20px;
}
.project a .zt-con {
    padding-right: 20px;
}
.project a:nth-child(4n+4) .zt-con {
    padding-right: 0;
}
.project a .zt-banner {
    overflow: hidden;
}
.project a .zt-banner img {
    width: 100%;
    height: 160px;
    transition: all .3s ease;
}
.project a p {
    height: 34px;
    font-size: 12px;
    color: #555;
    background: #eee;
    line-height: 18px;
    overflow: hidden;
    padding: 5px;
    transition: all .3s ease;
}
.project a:hover img {
    transform: scale(1.1);
}
.project a:hover p {
    color: #409eff;
}

@media(max-width: 868px) {
    .project {
        justify-content: space-between;
    }
    .project a {
        flex: 0 0 48%;
    }
    .project a .zt-con {
        padding-right: 0;
    }
    .project a .zt-banner img {
        height: 100%;
    }
}
</style>